<template>
  <div class="footer-box-other flex flex-jc-center flex-ai-center">
    <p class="footer-text">
      <span>{{ $t('footer.copy_ltd') }}</span>
      <a href="https://beian.miit.gov.cn">{{ $t('footer.icp') }}</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'OtherFooter'
}
</script>

<style lang="scss" scoped>
.footer-box-other {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 40px;
  padding: 0 20px;
  width: 100%;

  .footer-text {
    color: #999;
    font-size: 10px;
  }
  a {
    color: #999;
    text-decoration: auto;
  }
}
</style>
